module.exports = __webpack_public_path__ + "img/txt_info2.ad05b4f9.png";